export enum MenuStates {
  Closed,
  Open
};
